export enum IntegrationType {
  Analytics = 'analytics',
  CRM = 'crm',
  Financing = 'financing',
  Messaging = 'messaging',
  Other = 'other',
  Payments = 'payments',
  Taxes = 'taxes',
}
